export default "__VITE_ASSET__272bea56__"